// Mirrors the document minimum confirmServiceCompletion enforces (convex/app/duties/mutations.ts): one Notfallschein per Kassenpatient, at least one document.
export const requiredSettlementDocuments = (hasNotfallscheinbeteiligung: boolean | undefined, kassenpatienten: number | undefined): number =>
  hasNotfallscheinbeteiligung ? Math.max(1, kassenpatienten ?? 0) : 1;
